import {useSettings} from '@common/core/settings/use-settings';

export const usePaymentMethods = () => {
  const {
    billing: {
      stripe,
      phonesub,
      paypal,
      zain_sd,
      lebara,
      redbull,
      mobily,
      stc,
      sudani_spay,
      MTN_sd,
    },
  } = useSettings();

  return [
    {
      ...paypal,
      id: 'paypal',
      name: 'Paypal',
      enabled: paypal?.enable,
    },
    {
      ...stripe,
      id: 'stripe',
      name: 'Stripe',
      enabled: stripe?.enable,
    },
    {
      ...phonesub,
      id: 'phonesub',
      name: 'Zain KSA',
      enabled: phonesub?.enable,
    },
    {
      ...lebara,
      id: 'lebara',
      name: 'Lebara',
      enabled: lebara?.enable,
    },
    {
      ...redbull,
      id: 'redbull',
      name: 'Redbull',
      enabled: redbull?.enable,
    },
    {
      ...mobily,
      id: 'mobily',
      name: 'Mobily',
      enabled: mobily?.enable,
    },
    {
      ...stc,
      id: 'stc',
      name: 'STC',
      enabled: stc?.enable,
    },
    {
      ...zain_sd,
      id: 'zain_sd',
      name: 'Zain SD',
      enabled: zain_sd?.enable,
    },
    {
      ...sudani_spay,
      id: 'sudani_spay',
      name: 'Sudani SPAY',
      enabled: sudani_spay?.enable,
    },
    {
      ...MTN_sd,
      id: 'MTN_sd',
      name: 'MTN SD',
      enabled: MTN_sd?.enable,
    },
  ];
};
